import * as actions from './actions'
import { saveEntities } from '../factories'
import { showFeedback } from '../feedback/factories'
import { set } from 'cerebral/factories'
import { props } from 'cerebral'
import { loadProfilesSequence } from '../profiles/factories'
import { compose, path, pluck } from 'ramda'

const loadProfiles = loadProfilesSequence(compose(pluck('profile'), path(['props', 'entities', 'locationVehicleShifts'])), 'profileIds')

export const find = [
  //
  actions.find,
  saveEntities(),
  loadProfiles,
]

export const findForList = [
  //
  set(props`useRouteParams`, true),
  actions.find,
  actions.setList,
  saveEntities(),
  loadProfiles,
]

export const get = [
  //
  actions.get,
  saveEntities(),
]

export const remove = [
  //
  actions.remove,
  showFeedback({ title: 'Shift deleted', type: 'success' }),
  findForList,
]

export const updateEntities = [
  //
  saveEntities(),
  loadProfiles,
]

export const endShift = [
  //
  actions.endShift,
  saveEntities(),
]
